// extracted by mini-css-extract-plugin
export default {"teamMember":"MemberRow_teamMember__26F6B","icons":"MemberRow_icons__EeEEM"};